 (function () {  
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      if (!upsells) return
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!wrapper.querySelector('.cart-drawer-upsell-list li')) {
        wrapper.querySelector('#cart-drawer-upsell')?.remove()
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    // Refresca el upsell solo cuando el carrito cambia (antes observaba todo el drawer,
    // incluido el temporizador que cambia cada segundo, y descargaba la página completa en bucle).
    let upsellTimer
    async function refreshUpsells() {
      const wrapper = document.querySelector('#cart-drawer-upsell-wrapper')
      if (!wrapper) return
      try {
        const response = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
        const text = await response.text()
        const newWrapper = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#cart-drawer-upsell-wrapper')
        if (!newWrapper) return
        document.querySelector('#cart-drawer-upsell-wrapper')?.replaceWith(newWrapper)
        document.querySelector('#CartDrawer .cart-drawer-items-wrapper #cart-drawer-upsell')?.remove()
        const itemsWrapper = document.querySelector('#CartDrawer .cart-drawer-items-wrapper')
        if (itemsWrapper) {
          itemsWrapper.insertAdjacentHTML('beforeend', newWrapper.innerHTML)
          if (!itemsWrapper.querySelector('.cart-drawer-upsell-list li')) {
            itemsWrapper.querySelector('#cart-drawer-upsell')?.remove()
          }
        } else {
          insertSectionCartDrawer()
        }
      } catch (e) {}
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        clearTimeout(upsellTimer)
        upsellTimer = setTimeout(refreshUpsells, 300)
      })
    }

    // Cuando el drawer se vuelve a renderizar completo (al agregar un producto), reinserta el upsell.
    const cartDrawerInner = document.querySelector('#CartDrawer')
    if (cartDrawerInner) {
      new MutationObserver(() => insertSectionCartDrawer()).observe(cartDrawerInner, { childList: true })
    }
  })();